import request from '@/utils/request'

// 查询快码列表
export function apiLookupTypeList (query) {
  return request({
    url: '/system/lookup/type/list',
    method: 'get',
    params: query
  })
}

// 新增快码
export function apiLookupTypeAdd (data) {
  return request({
    url: '/system/lookup/type',
    method: 'post',
    data: data
  })
}

// 修改快码
export function apiLookupTypeUpdate (data) {
  return request({
    url: '/system/lookup/type',
    method: 'put',
    data: data
  })
}

// 删除快码
export function apiLookupTypeDelete (dictId) {
  return request({
    url: `/system/lookup/type/${dictId}`,
    method: 'delete'
  })
}

// 属性定义列表
export function apiLookupAttributeList (query) {
  return request({
    url: '/system/lookup/attribute/list',
    method: 'get',
    params: query
  })
}

// 属性-修改
export function apiLookupAttributeUpdate (data) {
  return request({
    url: '/system/lookup/attribute',
    method: 'put',
    data: data
  })
}
